<template>
  <div class="kv-ve-display" role="group" :aria-label="resolvedLabel">
    <button
      type="button"
      class="kv-ve-display__btn"
      :class="{ active: safeValue === 'block' }"
      :title="resolvedBlockTitle"
      :aria-label="resolvedBlockTitle"
      :aria-pressed="safeValue === 'block' ? 'true' : 'false'"
      @click="$emit('input', 'block')"
    >
      <span class="kv-ve-display__icon kv-ve-display__icon--block" aria-hidden="true">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </span>
    </button>
    <button
      type="button"
      class="kv-ve-display__btn"
      :class="{ active: safeValue === 'inline-block' }"
      :title="resolvedInlineTitle"
      :aria-label="resolvedInlineTitle"
      :aria-pressed="safeValue === 'inline-block' ? 'true' : 'false'"
      @click="$emit('input', 'inline-block')"
    >
      <span class="kv-ve-display__icon kv-ve-display__icon--inline" aria-hidden="true">
        <span class="box"></span>
        <span class="box"></span>
        <span class="box"></span>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: "VeDisplayModePicker",
  model: { prop: "value", event: "input" },
  props: {
    value: { type: String, default: "block" }, // block | inline-block
    label: { type: String, default: "" },
    blockTitle: { type: String, default: "" },
    inlineTitle: { type: String, default: "" },
  },
  computed: {
    resolvedLabel() {
      return this.label || this.t("visual_editor-display");
    },
    resolvedBlockTitle() {
      return this.blockTitle || this.t("visual_editor-block");
    },
    resolvedInlineTitle() {
      return this.inlineTitle || this.t("visual_editor-inline");
    },
    safeValue() {
      const v = String(this.value || "").toLowerCase();
      // Back-compat: treat "inline" as "inline-block"
      return v === "inline-block" || v === "inline" ? "inline-block" : "block";
    },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
  },
};
</script>

<style scoped lang="less">
.kv-ve-display {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}
.kv-ve-display__btn {
  all: unset;
  cursor: pointer;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  transition: box-shadow 0.15s ease, border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
  color: #344054;
}
.kv-ve-display__btn:hover {
  border-color: rgba(42, 170, 76, 0.55);
  box-shadow: 0 0 0 4px rgba(42, 170, 76, 0.12);
}
.kv-ve-display__btn.active {
  border-color: rgba(42, 170, 76, 0.85);
  box-shadow: 0 0 0 4px rgba(42, 170, 76, 0.16);
  background: rgba(42, 170, 76, 0.06);
  color: #027a48;
}

.kv-ve-display__icon {
  width: 26px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.kv-ve-display__icon--block {
  flex-direction: column;
  gap: 4px;
}
.kv-ve-display__icon--block .bar {
  width: 22px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
  opacity: 0.9;
}
.kv-ve-display__icon--inline {
  flex-direction: row;
}
.kv-ve-display__icon--inline .box {
  width: 10px;
  height: 10px;
  display: block;
  border-radius: 4px;
  background: currentColor;
  opacity: 0.85;
  padding: 0px 5px
}
</style>


